import axios from "axios";

export class Pallet {
  id: string | null;
  widthInCm: number;
  heightInCm: number;
  depthInCm: number;
  weightInKg: number;

  combinableWithKubus: boolean;

  description: string | null;

  constructor(id: string | null, widthInCm: number, heightInCm: number, depthInCm: number, weightInKg: number,
              combinableWithKubus: boolean, description: string | null) {
    this.id = id;
    this.widthInCm = widthInCm;
    this.heightInCm = heightInCm;
    this.depthInCm = depthInCm;
    this.weightInKg = weightInKg;
    this.combinableWithKubus = combinableWithKubus;
    this.description = description;
  }

  public buildTitle(): string {
    return this.description && this.description.length > 0 ? this.description : `${this.widthInCm} x ${this.depthInCm} x ${this.heightInCm}`
  }
}

interface PalletApi {
  list(): Promise<Pallet[]>;
  add(pallet: Pallet): Promise<string>;
  edit(pallet: Pallet): Promise<void>;
  delete(pallet: Pallet): Promise<void>;
}

export const palletApi: PalletApi = {
  async list() {
    return (await axios.get("/api/pallets")).data;
  },

  async edit(pallet) {
    return await axios.put(`/api/pallets/${pallet.id}`, pallet);
  },

  async add(pallet) {
    return (await axios.post("/api/pallets", pallet)).data;
  },

  async delete(pallet) {
    return await axios.delete(`/api/pallets/${pallet.id}`);
  },
};
